import React from 'react';
import { Form } from 'src/components/RcForm';

const ChangesMonitor = (props) => {
  const { setHasModified, pcForm, tabletForm, mobileForm, loaded } = props;
  const monitoringRef = React.useRef(false);
  const pD = Form.useWatch([], pcForm);
  const tD = Form.useWatch([], tabletForm);
  const mD = Form.useWatch([], mobileForm);

  React.useEffect(() => {
    if (!loaded) {
      monitoringRef.current = false;
      return;
    }
    if (!monitoringRef.current) {
      monitoringRef.current = true;
      return;
    }
    if (setHasModified) {
      setHasModified(true);
    }
  }, [loaded, pD, tD, mD]);
  return <React.Fragment />;
};
export default ChangesMonitor;
